import React, { Component } from 'react';

import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import FormFields from '../FormFields';
import CardWrapper from '../../../hoc/CardWrapper/CardWrapper';

import classes from './ForgotPasswordModalForm.module.css';
import { IsObjectEmpty, GetObjectClone, IsStringEmpty } from '../../../utilities/CommonMethods';
import UserAPIController from '../../../webServices/UserAPIController';
import Constants from '../../../utilities/Constants';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';

class ForgotPasswordModalForm extends Component {

	state = {
		forgotPasswordFormData: GetObjectClone(FormFields.forgotPasswordModalForm),
		forgotPasswordFormValid: false,
		showLoader: false,
		errorMessage: '',
		showError: false,
	}

	checkValidity = (formElement, formList) => {
		let isValid = true;

		if (!IsObjectEmpty(formElement.validation)) {
			let value = formElement.value;
			const rules = formElement.validation;
			if (!IsObjectEmpty(rules.required) && rules.required.value) {
				isValid = (value.length > 0) && isValid;
				formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
				formElement.valid = isValid;
			}
			if (!IsObjectEmpty(rules.isEmail) && rules.isEmail.value) {
				const validEmailFormat = Constants.REGEX_EMAIL_VALIDITY;
				isValid = validEmailFormat.test(value) && isValid;
				formElement.errorMessage = isValid ? '' : rules.isEmail.errorMessage;
				formElement.valid = isValid;
			}
		}
		return (formElement);
	}

	inputChangedHandler = (event, inputIdentifier) => {
		const updatedForm = { ...this.state.forgotPasswordFormData };
		let updatedFormElement = { ...updatedForm[inputIdentifier] };
		if (inputIdentifier === 'email') {
			updatedFormElement.value = event.target.value.toLowerCase();
		} else {
			updatedFormElement.value = event.target.value;
		}
		updatedFormElement.touched = true;
		updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
		updatedForm[inputIdentifier] = updatedFormElement;
		let formIsValid = true;
		for (let inputIdentifier in updatedForm) {
			if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
				formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
			}
		}
		this.setState({ forgotPasswordFormData: updatedForm, forgotPasswordFormValid: formIsValid, showError: false });
	}


	onEnterClicked = (e, key) => {
		if (e.which === 13 || e.keyCode === 13) {
			this.resetPasswordButtonClick();
		}
	}

	inputFieldsForgotPassword = (key) => {
		return <Input
			elementType={this.state.forgotPasswordFormData[key].elementType}
			elementConfig={this.state.forgotPasswordFormData[key].elementConfig}
			label={this.state.forgotPasswordFormData[key].label}
			value={this.state.forgotPasswordFormData[key].value}
			changed={(event) => this.inputChangedHandler(event, key)}
			keyDown={(event) => this.onEnterClicked(event, key)}
			touched={this.state.forgotPasswordFormData[key].touched}
			required={!IsObjectEmpty(this.state.forgotPasswordFormData[key].validation) ? (!IsObjectEmpty(this.state.forgotPasswordFormData[key].validation.required) ? this.state.forgotPasswordFormData[key].validation.required.value : false) : false}
			showError={(!this.state.forgotPasswordFormValid && !this.state.forgotPasswordFormData[key].valid) ? true : false}
			error={this.state.forgotPasswordFormData[key].errorMessage} />
	}

	resetPasswordButtonClick = () => {
		const updatedForm = { ...this.state.forgotPasswordFormData };
		for (let item in updatedForm) {
			updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
		}

		let formIsValid = true;
		for (let inputIdentifier in updatedForm) {
			if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
				formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
			}
		}
		this.setState({ forgotPasswordFormData: updatedForm, forgotPasswordFormValid: formIsValid });

		if (formIsValid) {
			this.setState({ showError: false, showLoader: true });
			let userEmail = { email: this.state.forgotPasswordFormData.email.value };
			UserAPIController.userForgotPassword(userEmail)
				.then(response => {
					this.setState({ showLoader: false });
					this.props.closeButtonClick();
					this.props.onSuccessDialogShow(response.result.message, 'OKAY');
				})
				.catch(err => {
					this.setState({ showLoader: false });
					if (err.error.status === 400) {
						if (!IsObjectEmpty(err.error.errorList)) {
							Error('ResetPwd Response ErrorList: ', err.error.errorList);
							const updatedForm = { ...this.state.forgotPasswordFormData };
							const errorList = { ...err.error.errorList };
							for (let item in errorList) {
								if (!IsStringEmpty(errorList[item])) {
									updatedForm[item].errorMessage = errorList[item];
									updatedForm[item].valid = !IsObjectEmpty(updatedForm[item]) ? false : true;
								}
							}

							let formIsValid = true;
							for (let inputIdentifier in updatedForm) {
								if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
									formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
								}
							}

							this.setState({ forgotPasswordFormData: updatedForm, forgotPasswordFormValid: false, showLoader: false });
						} else {
							Error('ResetPwd Response ErrorList: ', err.error.message);
							this.setState({ showLoader: false, showError: true, errorMessage: err.error.message });
							// this.props.onFailureDialogShow(err.error.message, 'OKAY');
						}
					}
					if (err.error.status === 401) {
						if (err.error.message === 'Invalid token.') {
							this.props.showSessionExpiredDialog(true);
						} else {
							this.props.redirectToUnauthorized();
						}
					}
					if (err.error.status === 404) {
						this.props.redirectToNotFound();
					}
					if (err.error.status === 500) {
						this.props.redirectToServerError();
					}
				});
		}
	}

	render() {
		return (
			<CardWrapper isLoading={this.state.showLoader} isModal={true} noShadow={true}>
				<div className={classes.Heading}>
					<p>Reset Passsword</p>

					<img
						className={classes.CloseIcon}
						src={closeIconBlack}
						alt="Close Sign In Modal"
						onClick={this.props.closeButtonClick}
					/>
				</div>
				<div className={classes.Container}>
					<div className={classes.Message}>
						<p>Enter your registered email ID and we'll send the link to reset your password</p>
					</div>
					<form autoComplete="off">
						<div className={classes.Form}>
							<input autoComplete="false" name="hidden" type="text" style={{ display: "none" }} />
							<div className={classes.Email}>{this.inputFieldsForgotPassword('email')}</div>
						</div>
					</form>
					{this.state.showError ? <p className={classes.ErrorText}>{this.state.errorMessage}</p> : null}
				</div>
				<div className={classes.ButtonContainer}>
					<Button
						styleclass="MobileOnly"
						fontSize="0.625em"
						label="RESET PASSWORD"
						disabled={false}
						tooltip={null}
						margin="16px 0px 20px 0px"
						clicked={this.resetPasswordButtonClick}
					/>
					<Button
						styleclass="NonMobileOnly"
						label="RESET PASSWORD"
						disabled={false}
						tooltip={null}
						margin="16px 0px 20px 0px"
						clicked={this.resetPasswordButtonClick}
					/>
				</div>
			</CardWrapper>
		);
	}
}



export default ForgotPasswordModalForm;